export const TABS_VARIANT_PILL = 'pill';
export const TABS_VARIANT_UNDERLINE = 'underline';

export type TabsVariant = typeof TABS_VARIANT_PILL | typeof TABS_VARIANT_UNDERLINE;
